webpackJsonp([56719701542624],{

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Accenture;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Accenture() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "112", height: "30", viewBox: "0 0 112 30" },
	    _react2.default.createElement(
	      "g",
	      { fill: "#0C1014", fillRule: "nonzero" },
	      _react2.default.createElement("path", {
	        id: "Path",
	        d: "M65.015 3.75l6.42 2.523-6.42 2.386v3.409l10.995-4.432v-2.727l-10.995-4.432z"
	      }),
	      _react2.default.createElement("path", {
	        d: "M6.078 16.432c-3.073 0-5.327 1.364-5.532 4.227h3.415v-.068c.068-.955.956-1.636 1.912-1.568 1.298 0 1.912.75 1.912 2.045v.614h-1.571c-3.346 0-6.078 1.023-6.078 4.227v.136c0 2.591 1.912 3.75 4.234 3.75 1.434.068 2.732-.614 3.551-1.705v1.5h3.483v-8.591c-.068-3.273-2.322-4.568-5.327-4.568zm-.751 10.841c-1.229 0-1.776-.614-1.776-1.5v-.136c0-1.159.888-1.636 2.663-1.636h1.434v1.227c.068 1.364-1.093 2.045-2.322 2.045z",
	        id: "Shape"
	      }),
	      _react2.default.createElement("path", {
	        d: "M19.6 27.136c-1.707 0-2.595-1.159-2.595-3.75v-.409c0-2.523 1.024-3.75 2.595-3.75 1.229 0 1.912.818 2.117 2.045h3.415c-.273-3.341-2.732-4.841-5.6-4.841-3.415 0-6.146 2.318-6.146 6.682v.136c0 4.364 2.595 6.545 6.146 6.545 3.483 0 5.463-2.114 5.737-4.977h-3.278c-.273 1.432-1.161 2.318-2.39 2.318zM32.917 27.136c-1.707 0-2.595-1.159-2.595-3.75v-.409c0-2.523 1.024-3.75 2.595-3.75 1.229 0 1.912.818 2.117 2.045h3.415c-.273-3.341-2.732-4.841-5.6-4.841-3.415 0-6.146 2.318-6.146 6.682v.136c0 4.364 2.595 6.545 6.146 6.545 3.483 0 5.463-2.114 5.668-4.977h-3.21c-.205 1.432-1.161 2.318-2.39 2.318z",
	        id: "Path"
	      }),
	      _react2.default.createElement("path", {
	        d: "M46.371 27.205c-1.571 0-2.527-.886-2.663-3.205h8.332v-1.5c0-4.227-2.663-6.068-5.873-6.068-3.483 0-6.146 2.386-6.146 6.682v.273c0 4.295 2.527 6.477 6.215 6.477 3.346 0 5.395-1.841 5.737-4.295h-3.346c-.137 1.023-1.161 1.773-2.254 1.636zm-.205-8.318c1.434 0 2.322.818 2.39 2.727h-4.78c.273-2.045 1.298-2.659 2.39-2.727z",
	        id: "Shape"
	      }),
	      _react2.default.createElement("path", { d: "M43.776 21.614h-.068zM61.737 16.432c-1.639-.068-3.141.75-3.893 2.182v-1.909h-3.551v12.818h3.551v-8.182c.068-1.159 1.093-2.114 2.254-2.045 1.298 0 1.912.682 1.912 2.182v8.045h3.62v-8.591c0-3.136-1.571-4.5-3.893-4.5zM72.322 25.432v-6.068h2.459v-2.659h-2.459v-3.886l-3.551 1.5v2.386h-1.571v2.659h1.502v6.477c0 2.591 1.298 3.886 4.098 3.886.683 0 1.366-.068 2.049-.273v-2.795c-.41.136-.82.205-1.229.205-.82 0-1.298-.477-1.298-1.432zM84.683 24.682v.341c-.068 1.159-1.093 2.114-2.254 2.045-1.298 0-1.844-.682-1.844-2.182v-8.182h-3.62v8.659c0 3 1.707 4.432 4.029 4.432 1.571.068 3.005-.75 3.756-2.182v1.909h3.62v-12.818h-3.62l-.068 7.977zM94.517 19.023v-2.386h-3.551v12.818h3.551v-6.614c0-2.114 1.434-2.864 3.893-2.864v-3.545c-1.776 0-3.346 1.023-3.893 2.591z" }),
	      _react2.default.createElement("path", { d: "M111.522 22.432c0-4.227-2.663-6-5.873-6-3.483 0-6.146 2.386-6.146 6.682v.273c0 4.295 2.527 6.477 6.215 6.477 3.346 0 5.327-1.841 5.737-4.295h-3.346c-.273 1.091-1.298 1.773-2.39 1.705-1.571 0-2.527-.886-2.663-3.205h8.332v-1.636h.137zm-8.332-.818c.273-2.114 1.298-2.727 2.459-2.727 1.434 0 2.322.818 2.39 2.727h-4.849z" })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Deloitte;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Deloitte() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "102", height: "30", viewBox: "0 0 102 30" },
	    _react2.default.createElement(
	      "g",
	      { fill: "#0C1014", fillRule: "nonzero" },
	      _react2.default.createElement("path", { d: "M95.638 27.292c0-1.484 1.2-2.687 2.676-2.687 1.478 0 2.676 1.204 2.676 2.687 0 1.484-1.198 2.687-2.676 2.687-1.477 0-2.676-1.203-2.676-2.687" }),
	      _react2.default.createElement("path", { d: "M10.282 20.175c0-1.702-.328-2.965-.983-3.788-.656-.822-1.65-1.232-2.985-1.232h-1.421v10.409h1.087c1.484 0 2.571-.442 3.263-1.328.692-.885 1.038-2.239 1.038-4.06m5.068-.177c0 3.101-.83 5.49-2.491 7.168-1.66 1.678-3.995 2.517-7.003 2.517h-5.846v-18.582h6.254c2.901 0 5.141.763 6.719 2.288 1.578 1.526 2.367 3.728 2.367 6.609" }),
	      _react2.default.createElement("path", { d: "M31.544 29.682h4.652v-18.659h-4.652z" }),
	      _react2.default.createElement("path", { d: "M42.731 22.722c0 1.19.155 2.097.464 2.721.31.624.829.936 1.558.936.722 0 1.232-.312 1.53-.936.297-.624.445-1.531.445-2.721 0-1.183-.15-2.076-.451-2.679-.302-.604-.817-.907-1.547-.907-.714 0-1.224.301-1.534.9-.309.6-.464 1.494-.464 2.686m8.732 0c0 2.267-.592 4.035-1.778 5.302-1.186 1.268-2.845 1.903-4.979 1.903-2.046 0-3.675-.648-4.884-1.945-1.21-1.297-1.815-3.05-1.815-5.259 0-2.26.592-4.015 1.779-5.267 1.186-1.252 2.85-1.878 4.992-1.878 1.324 0 2.494.29 3.509.869 1.015.579 1.799 1.409 2.35 2.49.551 1.079.826 2.342.826 3.786" }),
	      _react2.default.createElement("path", { d: "M53.31 29.682h4.653v-13.86h-4.653z" }),
	      _react2.default.createElement("path", { d: "M53.31 14.145h4.653v-3.123h-4.653z" }),
	      _react2.default.createElement("path", { d: "M67.389 26.147c.628 0 1.376-.16 2.249-.478v3.487c-.627.277-1.224.475-1.79.593-.567.119-1.232.178-1.993.178-1.562 0-2.688-.394-3.38-1.181-.688-.787-1.034-1.995-1.034-3.626v-5.714h-1.629v-3.583h1.629v-3.539l4.688-.819v4.358h2.968v3.583h-2.968v5.395c0 .897.42 1.346 1.26 1.346" }),
	      _react2.default.createElement("path", { d: "M78.157 26.147c.628 0 1.376-.16 2.249-.478v3.487c-.626.277-1.224.475-1.79.593-.568.119-1.231.178-1.993.178-1.562 0-2.688-.394-3.378-1.181s-1.035-1.995-1.035-3.626v-5.714h-1.63v-3.583h1.63v-3.593l4.688-.765v4.358h2.97v3.583h-2.97v5.395c0 .897.421 1.346 1.261 1.346" }),
	      _react2.default.createElement("path", { d: "M86.277 21.033c.064-.759.28-1.315.648-1.67.37-.355.827-.532 1.374-.532.596 0 1.07.199 1.422.6.354.399.538.933.553 1.602h-3.997zm6.561-3.823c-1.106-1.089-2.675-1.634-4.705-1.634-2.134 0-3.775.626-4.926 1.878-1.15 1.252-1.725 3.048-1.725 5.389 0 2.267.622 4.015 1.863 5.242 1.241 1.227 2.985 1.841 5.23 1.841 1.078 0 2.006-.074 2.783-.221.773-.145 1.521-.408 2.247-.788l-.715-3.123c-.527.216-1.029.383-1.503.492-.685.159-1.436.239-2.254.239-.897 0-1.605-.22-2.123-.66-.519-.441-.795-1.049-.827-1.823h8.316v-2.128c0-2.047-.553-3.616-1.66-4.704z" }),
	      _react2.default.createElement("path", { d: "M21.524 21.033c.064-.759.28-1.315.648-1.67.369-.355.827-.532 1.375-.532.595 0 1.069.199 1.421.6.354.399.537.933.554 1.602h-3.998zm6.562-3.823c-1.107-1.089-2.675-1.634-4.705-1.634-2.134 0-3.775.626-4.925 1.878-1.15 1.252-1.726 3.048-1.726 5.389 0 2.267.621 4.015 1.863 5.242 1.241 1.227 2.984 1.841 5.229 1.841 1.078 0 2.006-.074 2.783-.221.773-.145 1.521-.408 2.247-.788l-.716-3.123c-.527.216-1.029.383-1.502.492-.686.159-1.437.239-2.254.239-.896 0-1.605-.22-2.123-.66-.52-.441-.795-1.049-.827-1.823h8.316v-2.128c0-2.047-.553-3.616-1.659-4.704z" })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _generalModule = __webpack_require__(250);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cta(_ref) {
	  var heading = _ref.heading,
	      ctaLink = _ref.ctaLink;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.cta },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', sizeM: '0', position: 'leftRight', type: 'padding' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 760 },
	            _react2.default.createElement(
	              _heading2.default,
	              { size: 'xxxl', weight: 'semibold', color: 'black' },
	              heading
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: ctaLink },
	        _react2.default.createElement(
	          _button2.default,
	          { shape: 'rounded', kind: 'flat', size: 'large' },
	          'Request a demo'
	        )
	      )
	    )
	  );
	}
	
	Cta.propTypes = {
	  heading: _customPropTypesCheck2.default,
	  ctaLink: _propTypes2.default.string
	};
	
	Cta.defaultProps = {
	  heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cta":"src-components-modules-Cta-CtaDemo-style----general-module---cta---35v6-"};

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = IndustryHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _headerModule = __webpack_require__(253);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function IndustryHeader(_ref) {
	  var label = _ref.label,
	      imageAsset = _ref.imageAsset,
	      title = _ref.title,
	      paragraph = _ref.paragraph,
	      ctaLink = _ref.ctaLink;
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: ctaLink },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: 'blue',
	              hover: 'blue',
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.flex },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.firstCol },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', position: 'bottom', type: 'margin' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'm', weight: 'semibold' },
	            _react2.default.createElement(
	              'span',
	              { className: _headerModule2.default.label },
	              label
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: _headerModule2.default.heading },
	          title
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 500 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'm', color: 'black' },
	              paragraph
	            )
	          )
	        ),
	        buttons
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.secondCol },
	      _react2.default.createElement(_Image2.default, _extends({}, imageAsset, { hasShadow: false, block: true }))
	    )
	  );
	}
	
	IndustryHeader.propTypes = {
	  imageAsset: _propTypes2.default.object,
	  label: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  paragraph: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  ctaLink: _propTypes2.default.string.isRequired
	};
	
	IndustryHeader.defaultProps = {
	  ctaLink: '/enterprise/request-demo'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-IndustryHeader-style----header-module---flex---2XcZw pageWrap pageWrap-l alignItems-center justifyContent-center breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-components-modules-IndustryHeader-style----header-module---firstCol---284-C breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-components-modules-IndustryHeader-style----header-module---buttons---CnkfF breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","label":"src-components-modules-IndustryHeader-style----header-module---label---715vJ","leftButton":"src-components-modules-IndustryHeader-style----header-module---leftButton---7UUP8 breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","heading":"src-components-modules-IndustryHeader-style----header-module---heading---2IHjT fontWeight-5 marginBottom-m fontSize-xxxl breakPointS-fontSize-xxxxl","rightButton":"src-components-modules-IndustryHeader-style----header-module---rightButton---3L5Nk breakPointM-paddingLeft-xxs","secondCol":"src-components-modules-IndustryHeader-style----header-module---secondCol---2NiBb"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logosModule = __webpack_require__(254);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos(_ref) {
	  var logos = _ref.logos,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'black' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.flex },
	      _react2.default.createElement(_logoRow2.default, {
	        logos: logos,
	        align: 'center',
	        color: 'black',
	        opacity: 100,
	        spacing: 'm'
	      })
	    )
	  );
	}
	
	Logos.propTypes = {
	  title: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  logos: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array])
	};
	module.exports = exports['default'];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-Logos-style----logos-module---flex---1UFmy alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-Logos-style----logos-module---cta---2mOF- paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 1223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _collaborate2x = __webpack_require__(2541);
	
	var _collaborate2x2 = _interopRequireDefault(_collaborate2x);
	
	var _democratise2x = __webpack_require__(863);
	
	var _democratise2x2 = _interopRequireDefault(_democratise2x);
	
	var _feedback2x = __webpack_require__(2542);
	
	var _feedback2x2 = _interopRequireDefault(_feedback2x);
	
	var _hero2x = __webpack_require__(2543);
	
	var _hero2x2 = _interopRequireDefault(_hero2x);
	
	var _validate2x = __webpack_require__(2545);
	
	var _validate2x2 = _interopRequireDefault(_validate2x);
	
	var _scale2x = __webpack_require__(2544);
	
	var _scale2x2 = _interopRequireDefault(_scale2x);
	
	var _ogPreview = __webpack_require__(511);
	
	var _ogPreview2 = _interopRequireDefault(_ogPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: 'Drive digital transformation through innovative design',
	    src: _hero2x2.default,
	    maxWidth: 660
	  },
	  democratise: {
	    alt: 'Democratise design by giving every team access to the right tools',
	    src: _democratise2x2.default,
	    maxWidth: 660
	  },
	  feedback: {
	    alt: 'Get buy-in early on with feedback loops reduced to minutes, not days',
	    src: _feedback2x2.default,
	    maxWidth: 660
	  },
	  collaborate: {
	    alt: 'Co-creation tools that turn clients into collaborators',
	    src: _collaborate2x2.default,
	    maxWidth: 600
	  },
	  validate: {
	    alt: 'Validate ideas at speed with user testing',
	    src: _validate2x2.default,
	    maxWidth: 1000
	  },
	  scale: {
	    alt: 'Democratise design and drive digital transformation',
	    src: _scale2x2.default,
	    maxWidth: 660
	  },
	  sharePreview: {
	    src: _ogPreview2.default,
	    maxWidth: 1200
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Accenture = __webpack_require__(1137);
	
	var _Accenture2 = _interopRequireDefault(_Accenture);
	
	var _Deloitte = __webpack_require__(1141);
	
	var _Deloitte2 = _interopRequireDefault(_Deloitte);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logos = [{
	  id: 0,
	  logo: _Accenture2.default
	}, {
	  id: 1,
	  logo: _Deloitte2.default
	}];
	
	exports.default = logos;
	module.exports = exports['default'];

/***/ }),

/***/ 2541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/collaborate@2x-cc2eeaee96716746c9f5bd84a9b4ca31.jpg";

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/democratise@2x-fcb93c33bc9e2798b7af1400a7a95090.jpg";

/***/ }),

/***/ 2542:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feedback@2x-9ed495270174fa0a3d21e37b205a876f.jpg";

/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero@2x-015591ed80d82f7e8bb3db8fbf954f49.jpg";

/***/ }),

/***/ 2544:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scale@2x-5eaf86a6f5540881918502bbef6e08b4.jpg";

/***/ }),

/***/ 2545:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/validate@2x-f3513da936bf8d809909221e042099a2.jpg";

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Consultancies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(1223);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _logos = __webpack_require__(1224);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _CtaDemo = __webpack_require__(199);
	
	var _CtaDemo2 = _interopRequireDefault(_CtaDemo);
	
	var _Logos = __webpack_require__(206);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _IndustryHeader = __webpack_require__(204);
	
	var _IndustryHeader2 = _interopRequireDefault(_IndustryHeader);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'Marvel for Consulting - Drive innovation through design'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Consulting'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/financial-services'
	}, {
	  name: 'og:description',
	  content: "Explore how Marvel's collaborative design platform can help introduce innovation management and design thinking for digital transformation."
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel for Consulting'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/financial-services'
	}, {
	  name: 'twitter:creator',
	  content: '@marvelapp'
	}, {
	  name: 'twitter:title',
	  content: 'Marvel for Consulting - Drive innovation through design'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}];
	
	var meta = {
	  title: _metadata2.default.consultancies.title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default.consultancies.description
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: false
	};
	
	function Consultancies() {
	  var ctaLink = '/enterprise/request-demo?hformid=' + _hubspot.requestDemoConsultancyId;
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_IndustryHeader2.default, {
	      label: 'Marvel for Consultancies',
	      imageAsset: _assets2.default.hero,
	      title: 'Drive digital transformation through innovative design',
	      paragraph: _react2.default.createElement(
	        'span',
	        null,
	        'Marvel helps consultancies around the world deliver exceptional client and customer experiences through a suite of tools that power collaborative design, prototyping and testing at scale. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Set your clients up for success through delivering innovative, user-centric design solutions with Marvel.'
	      ),
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_Logos2.default, {
	      title: _react2.default.createElement(
	        'span',
	        null,
	        'Join these leading consulting companies who use',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { style: { fontWeight: 'bold' } },
	          'Marvel Enterprise'
	        ),
	        ' to scale design'
	      ),
	      logos: _logos2.default
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Democratise design by giving every team access to the right tools',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'From designers to researchers and analysts, Marvel consolidates and simplifies dozens of professional, creative workflow tools - enabling every department to wireframe, design and prototype. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'We strive to lower the entry barrier for design and creative tooling. That\'s why it takes less than 30 minutes to onboard and complete your first project with Marvel. With no learning curve, our platform empowers every team to drive a design-led culture.'
	      ),
	      headingMaxWidth: 390,
	      paragraphMaxWidth: 480,
	      imageAsset: _assets2.default.democratise,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Get buy-in early on with feedback loops reduced to minutes, not days',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Increase transparency between teams, managers and stakeholders with Marvel\'s open collaboration tools, including comments, annotations and visibility dashboards. You\'ll see feedback become more contextual and meaningful, instantly.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'With Marvel, you\'ll experience a streamlined sign-off workflow, moving effortlessly from idea through to delivery.'
	      ),
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.feedback,
	      isRightAligned: true,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Co-creation tools that turn clients into collaborators',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'We believe that the strongest relationships form when clients are made to feel part of the process. Marvel helps you keep clients and stakeholders in the loop every step of the way, whether you\'re brainstorming or reviewing final designs.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Our apps help you turn paper sketches into interactive prototypes, great for early stage concepts during client sessions. Further along, prototypes will update design changes in real time from Sketch. Need to control access to prototypes? We have a range of user roles including an external reviewer setting.'
	      ),
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.collaborate,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Validate ideas at speed with user testing',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Reach your client\'s end-users and generate valuable data to help you and clients create innovative and user-centric design solutions. Marvel comes with User Testing built in, which means you can get rich video, audio and analytical feedback on your designs in just a few clicks.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        'Test with your team, clients and end-users by simply sending a link. No hardware or lab required!'
	      ),
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.validate,
	      isRightAligned: true,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'The tools you need to scale Design Thinking',
	      copy: 'Our platform and content help power workshops around problem-solving approaches including design sprints, code-free prototyping, helping up-skill non-designers with modern idea-to-launch methodologies and frameworks.',
	      headingMaxWidth: 458,
	      paragraphMaxWidth: 458,
	      imageAsset: _assets2.default.scale,
	      ctaLink: ctaLink
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'bg-snow' },
	      _react2.default.createElement(_CtaDemo2.default, {
	        heading: 'Challenge the industry norm and become a CX centric design leader with Marvel Enterprise.',
	        ctaLink: ctaLink
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-consultancies-index-js-2588b66b33bd7006545e.js